import { render } from "./SuccessPage.vue?vue&type=template&id=bd26a196&scoped=true"
import script from "./SuccessPage.vue?vue&type=script&lang=ts"
export * from "./SuccessPage.vue?vue&type=script&lang=ts"

import "./SuccessPage.vue?vue&type=style&index=0&id=bd26a196&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bd26a196"

export default script